export const container = `w-full`;
export const title = `text-xs text-gray-400 mb-2`;
export const list = `flex flex-col gap-y-1`;
export const item = `inline-flex group/poi-list-item`;
export const button = `
  w-full pl-4 border rounded transition-colors
  bg-base-white border-gray-150 text-gray-400 fill-gray-400

  hover:bg-primary-100
  hover:border-primary-100
  hover:text-base-white
  hover:fill-base-white

  group-data-[is-active=true]/poi-list-item:bg-primary-100
`;
export const poi = `flex justify-between w-full items-center text-left grow h-8`;
export const name = `text-xs font-medium truncate overflow-hidden text-nowrap w-52 group-data-[is-active=true]/poi-list-item:text-base-white`;
export const icon = `w-3 h-3 mr-2 group-data-[is-active=true]/poi-list-item:fill-base-white`;
export const routes = `block pb-2`;
export const schoolTypes = `flex flex-wrap gap-1 mb-2`;
export const badge = `text-xs py-0.5 px-2 bg-gray-150 text-base-black rounded`;
